import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import withContext from '../../withContext';
import ProductItem from './ProductItem';
import { trackShopTabSwitch } from '../../firebase';

class Shop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fadeIn: false
    };
  }

  componentDidMount() {
    document.body.style.paddingTop = "6em";
    this.props.context.refresh();
    window.scrollTo(0, 0);
    // Trigger fade-in after a brief delay
    setTimeout(() => this.setState({ fadeIn: true }), 50);
  }

  componentWillUnmount() {
    document.body.style.paddingTop = "0";
  }

  render() {
    const { products, user } = this.props.context;

    return (
      <Tab.Container defaultActiveKey="first">
        <div className={`shop-tabs-container page-transition ${this.state.fadeIn ? 'fade-in' : ''}`}>
          <Nav className="shop-tabs-nav justify-content-center" onSelect={(key) => trackShopTabSwitch(key)}>
            <Nav.Item>
              <Nav.Link eventKey="first" className="shop-tab-link" aria-label="Paintings">
                Paintings
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="second" className="shop-tab-link" aria-label="Prints">
                Prints
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="three" className="shop-tab-link" aria-label="Crafts">
                Crafts
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>

        <Col className="pb-4 pt-4">
          <Tab.Content>
            <Tab.Pane eventKey="first">
              <Container>
                <Row>
                  {products && products.length ? (
                    products
                      .filter((product) => product.type === 'Section1')
                      .map((product, index) => (
                        <Col md={4} className="mb-4 shop-product-col" key={index}>
                          <ProductItem
                            product={product}
                            addToCart={this.props.context.addToCart}
                            user={user}
                          />
                        </Col>
                      ))
                  ) : (
                    <Col>
                      <div className="text-center">
                        <span className="title has-text-grey-light">
                          No products found!
                        </span>
                      </div>
                    </Col>
                  )}
                </Row>
              </Container>
            </Tab.Pane>

            <Tab.Pane eventKey="second">
              <Container>
                <Row>
                  {products && products.length ? (
                    products
                      .filter((product) => product.type === 'Section2')
                      .map((product, index) => (
                        <Col md={4} className="mb-4 shop-product-col" key={index}>
                          <ProductItem
                            product={product}
                            addToCart={this.props.context.addToCart}
                            user={user}
                          />
                        </Col>
                      ))
                  ) : (
                    <Col>
                      <div className="text-center">
                        <span className="title has-text-grey-light">
                          No products found!
                        </span>
                      </div>
                    </Col>
                  )}
                </Row>
              </Container>
            </Tab.Pane>

            <Tab.Pane eventKey="three">
              <Container>
                <Row>
                  {products && products.length ? (
                    products
                      .filter((product) => product.type === 'Section3')
                      .map((product, index) => (
                        <Col md={4} className="mb-4 shop-product-col" key={index}>
                          <ProductItem
                            product={product}
                            addToCart={this.props.context.addToCart}
                            user={user}
                          />
                        </Col>
                      ))
                  ) : (
                    <Col>
                      <div className="text-center">
                        <span className="title has-text-grey-light">
                          No products found!
                        </span>
                      </div>
                    </Col>
                  )}
                </Row>
              </Container>
            </Tab.Pane>
          </Tab.Content>
        </Col>
      </Tab.Container>
    );
  }
}

export default withContext(Shop);